import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Router from "next/router";

import KButton from "@kikoff/components/src/v1/buttons/KButton";
import { web } from "@kikoff/proto/src/protos";
import { webRPC } from "@kikoff/proto/src/rpc";

import PageAlign from "@component/dashboard/offer/page_align";
import { PageRegistration } from "@component/flows/hooks/usePageFlow";
import { MessageLoader } from "@component/loading_indicators/loading_indicators";
import StreamlinedHeader from "@component/onboarding/streamlined_header";
import { fetchUser } from "@feature/user";
import { track } from "@util/analytics";

import styles from "./reverification.module.scss";

interface ReverificationPageProps extends PageRegistration {}

export default function ReverificationPage({ page }: ReverificationPageProps) {
  const dispatch = useDispatch();

  const [state, setState] = useState("timeout");

  function pollRisk() {
    setState("pending");
    let tries = 20;

    (function pollNext() {
      webRPC.Reverification.getReverificationStatus({}).then((res) => {
        const status =
          web.public_.GetReverificationStatusResponse.RiskStatus[res.status];

        switch (status) {
          case "UNKNOWN":
            Router.replace("/dashboard");
            break;
          case "PENDING":
            tries--;
            if (tries) setTimeout(pollNext, 3000);
            else setState("timeout");
            break;
          case "PASSED":
            track("Identity Reverification - Success");
            setTimeout(() => {
              dispatch(fetchUser.features());
              page.controller.next();
            }, 1500);
            break;
          case "FAILED":
            track("Identity Reverification - Error");
            Router.replace("/dashboard/store/reverification-failed");
            break;
          default:
        }
      });
    })();
  }

  useEffect(() => {
    pollRisk();
  }, []);

  return (
    <PageAlign className={styles["reverification-page"]} scroll>
      <StreamlinedHeader page={page} />
      <div>
        {
          {
            pending: (
              <div>
                <MessageLoader
                  main="Verifying your identity..."
                  sub="This should only take a bit"
                />
              </div>
            ),
            timeout: (
              <div className={styles.timeout}>
                <header className="text:heading-4 mt-8">
                  Identity verification timed out, please try again later.
                </header>
                <KButton
                  variant="black"
                  size="standard"
                  onClick={() => pollRisk()}
                  className="mx-1"
                >
                  Try again
                </KButton>
                <KButton
                  variant="black"
                  size="standard"
                  onClick={() => Router.replace("/dashboard")}
                  className="mx-1"
                >
                  Go home
                </KButton>
              </div>
            ),
          }[state]
        }
      </div>
    </PageAlign>
  );
}
